import { Box, Divider, Typography } from '@mui/material';
import {
  DialogActions,
  DialogBody,
  DialogContainer,
  DialogTitle,
  LabelContent,
} from '../../../common/components';
import {
  formatAuditTimestamp,
  formatAuditUser,
  formatRequestPath,
  formatHttpMethod,
} from '../utils/formatters';

const parseDetailValue = (value) => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string') {
    try {
      const parsed = JSON.parse(value);
      return JSON.stringify(parsed, null, 2);
    } catch (error) {
      return value;
    }
  }
  if (typeof value === 'object') {
    try {
      return JSON.stringify(value, null, 2);
    } catch (error) {
      return String(value);
    }
  }
  return String(value);
};

const AuditDetailsDialog = ({ open, onClose, action }) => {
  if (!action) return null;

  const summaryFields = [
    { label: 'Fecha y hora', value: formatAuditTimestamp(action.created_at) },
    { label: 'Usuario', value: formatAuditUser(action) },
    { label: 'Módulo', value: action.module?.display_name || action.module?.key || '—' },
    { label: 'Método HTTP', value: formatHttpMethod(action.http_method) },
    { label: 'Endpoint', value: formatRequestPath(action.request_path, action.endpoint) },
    { label: 'Código de estado', value: action.status_code },
    { label: 'Descripción', value: action.description || '—' },
    { label: 'Dirección IP', value: action.remote_addr || '—' },
    { label: 'User Agent', value: action.user_agent || '—' },
  ];

  return (
    <DialogContainer open={open} onClose={onClose} size="large">
      <DialogTitle>Detalle de acción auditada</DialogTitle>

      <DialogBody sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2 }}>
          {summaryFields.map((field) => {
            const rawValue = field.value;
            const displayValue =
              rawValue === null || rawValue === undefined || rawValue === ''
                ? '—'
                : rawValue;

            return (
              <LabelContent
                key={field.label}
                label={field.label}
                content={displayValue}
              />
            );
          })}
        </Box>

        <Divider />

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography variant="h6">Detalles registrados</Typography>
          {action.details && action.details.length > 0 ? (
            action.details.map((detail) => (
              <Box
                key={detail.id}
                sx={{
                  border: (theme) => `1px solid ${theme.palette.divider}`,
                  borderRadius: 1,
                  p: 2,
                  backgroundColor: 'background.paper',
                }}
              >
                {detail.label && (
                  <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
                    {detail.label}
                  </Typography>
                )}
                <Typography
                  component="pre"
                  sx={{
                    m: 0,
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    fontFamily: 'inherit',
                    fontSize: '0.9rem',
                  }}
                >
                  {parseDetailValue(detail.value)}
                </Typography>
              </Box>
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No se registraron detalles adicionales para esta acción.
            </Typography>
          )}
        </Box>
      </DialogBody>

      <DialogActions handleClose={onClose} handleSave={onClose}/>
    </DialogContainer>
  );
};

export default AuditDetailsDialog;
